import { Contractor } from '@/models/Contractor';
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import MiForm, { MiFormField } from '@/components/MiForm/MiForm.ts';
import { ContractorFeedback, CreateFeedbackPayload } from '@/models/ContractorFeedback';
import { AxiosError, AxiosResponse } from 'axios';
import ErrorHandler from '@/support/ErrorHandler';

@Component<CreateFeedbackDialog>({ })
export default class CreateFeedbackDialog extends Vue {
  @Prop()
  protected contractorId!: string;

  @Prop()
  protected reportId!: string;

  @Prop()
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  protected typeItems!: any[];

  protected isLoading = true;

  protected mounted(): void {
    this.$nextTick(() => {
      this.isLoading = false;
    });
  }

  protected close(): void {
    this.$emit('input', false);
  }

  protected get form(): MiForm {
    return this.$refs.feedbackForm as MiForm;
  }

  protected get isValid(): boolean {
    if (this.isLoading) {
      return false;
    }
    return this.form.isFormValid();
  }

  protected async createFeedback(): Promise<void> {
    const data = await this.form.parseFromData();
    const payload: CreateFeedbackPayload = {
      type: data.type.value,
      body: data.body,
    };

    if (this.contractorId) {
      payload.contractor = this.contractorId;
    }

    if (this.reportId) {
      payload.report = this.reportId;
    }

    new ContractorFeedback()
      .include(['report', 'contractor'])
      .create(payload)
      .then((response: AxiosResponse) => {
        this.feedbackCreated(response);
        this.close();
      })
      .catch((error: AxiosError) => {
        ErrorHandler.network(error);
      });
  }

  @Emit()
  protected feedbackCreated(response: AxiosResponse): AxiosResponse {
    return response;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  protected async fetchFeedbackTypes(): Promise<any> {
    return new ContractorFeedback().listFeedbackTypes();
  }

  protected get feedbackFields(): MiFormField[] {
    return [
      {
        type: 'select',
        key: 'type',
        itemValue: 'value',
        itemText: 'text',
        items: this.typeItems,
        label: 'Type feedback',
        placeholder: 'Kies een type feedback',
        rules: ['required'],
        returnObject: true,
      },
      {
        type: 'textarea',
        key: 'body',
        placeholder: 'Beschrijving',
        label: 'Beschrijving',
        rules: ['required'],
      },
    ];
  }
}
